var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9593 2.50202V1.04602H12.8413V0.0460205H8.0753V1.04602H9.95928V2.50202C7.69045 2.63215 5.56174 3.64168 4.02531 5.31616C2.48888 6.99065 1.66579 9.19816 1.73088 11.4698C1.79597 13.7414 2.74411 15.8982 4.3739 17.4819C6.0037 19.0657 8.18673 19.9517 10.4593 19.9517C12.7318 19.9517 14.9149 19.0657 16.5447 17.4819C18.1745 15.8982 19.1226 13.7414 19.1877 11.4698C19.2528 9.19816 18.4297 6.99065 16.8933 5.31616C15.3568 3.64168 13.2281 2.63215 10.9593 2.50202H10.9593ZM12.2593 9.73402H9.6253V10.742H12.2593V13.708L10.8113 13.706V14.77H9.80927V13.706L8.6253 13.704V12.704L11.2593 12.706V11.742L8.6253 11.744V8.73402H9.94127V7.67202H10.9433V8.73402H12.2593L12.2593 9.73402Z",
    fill: "#C61E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2244 2.37981L16.5173 3.08691L18.5674 5.13696L19.2745 4.42985L17.2244 2.37981Z",
    fill: "#C61E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFees);
export default __webpack_public_path__ + "static/media/Fees.d23f1225.svg";
export { ForwardRef as ReactComponent };